/*
 * @Author: zhangjingqing
 * @Date: 2022-02-10 22:54:32
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-24 20:38:45
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\router\index.js
 */
import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { constantRouterMap, appMap, adminMap,admin3Map } from "./router.config";
import { getQueryString } from "@/utils/utils";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_API,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});

export function initDynamicRoutes() {
  if (store.getters.userInfo) {
    console.log("123456",store.getters.userInfo)
    let isAdmin = store.getters.userInfo.tenantId === null;
    if (isAdmin) {
      if(store.getters.userInfo.type ===1){
        router.addRoutes(adminMap);
      }else if(store.getters.userInfo.type === 3){
        router.addRoutes(admin3Map);
      }

    } else {
      router.addRoutes(appMap);
    }
  }
  if (getQueryString("token")) {
    router.addRoutes(appMap);
  }
}

export default router;
